/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
// declare global {
//     interface Window {
//         // eslint-disable-next-line @typescript-eslint/naming-convention
//         UdeskApiObject: string;
//         ud: AnyFunc & { d: any[] };
//     }
// }

// import sha1 from 'crypto-js/sha1'
// import { useVisible } from 'qdll-business'
import { openClientelServe } from '@/compose/clientelServe'

// import ClienteleServicesDialog from '@/components/ClienteleServicesDialog.vue'
// import { NTW_TYPE, NTW_VERSION } from '@/constant'
// import { globalModule } from '@/store'

/**
 *  产生一定长度的随机字符串
 */
export function randomString(len = 32) {
    const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    const maxPos = chars.length
    let pwd = ''
    for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
}


// const IM_CUSTOMER_KEY = 'c189f90142aaeb0adf26a20f81fcb30d'
// const CS_CONFIG: Partial<Record<
//     keyof typeof NTW_VERSION,
//     {
//         link: string;
//         groupId: number;
//         webPluginId: number;
//     }
// >> = {
//     scrm: {
//         link: 'https://1390767.s4.udesk.cn/im_client/?web_plugin_id=26591&group_id=27933',
//         groupId: 27933,
//         webPluginId: 26591
//     },
//     basic: {
//         link: 'https://1390767.s4.udesk.cn/im_client/?web_plugin_id=26549&group_id=27931&language=zh-cn',
//         groupId: 27931,
//         webPluginId: 26549
//     },
//     mkt: {
//         link: 'https://1390767.s4.udesk.cn/im_client/?web_plugin_id=26550&group_id=27932&language=zh-cn',
//         groupId: 27932,
//         webPluginId: 26550
//     }
// }

export const openGlobalCustomerService = () => {
    // const eventDiv = document.querySelector('#dingdan-global-customer-service')
    // eventDiv?.dispatchEvent(new Event('click'))
    // useVisible(ClienteleServicesDialog)
    // closeClientelServe
    openClientelServe()
}



export const initGlobalCustomerService = () => {
    // if (!document.querySelector('#dingdan-global-customer-service')) {
    //     const script = document.createElement('script')
    //     script.defer = true
    //     script.src = 'https://im.7x24cc.com/openPlatform/js/originateInformation.js'
    //     const tag = document.getElementsByTagName('script')[0]
    //     tag && tag.parentNode && tag.parentNode.insertBefore(script, tag)
    //     window.onload = function () {
    //         setTimeout(function () {
    //             hollycrm.originate.getChatUrl({
    //                 channelID: "1e8a25c8-0f28-472a-a041-c61ecb35cba2",
    //                 accountID: "N000000011595",
    //                 urlParam: {
    //                     visitorId: "test1",
    //                     nickName: "小小叶"
    //                 }
    //             }, function (callbackData) {
    //                 src = callbackData.chatUrl;
    //                 showChat();
    //                 // window.location.href = callbackData.chatUrl;
    //             });
    //         },5000)
    //     }
    // }
    // const version = (globalModule.networkInfo.finalVersion as keyof typeof NTW_VERSION) || 'basic'
    // const { link, groupId } = CS_CONFIG[version] || CS_CONFIG.basic!
    // window.UdeskApiObject = 'ud'
    // window.ud =
    //     window.ud ||
    //     function() {
    //         // eslint-disable-next-line prefer-rest-params
    //         (window.ud.d = window.ud.d || []).push(arguments)
    //     }
    // if (!document.querySelector('#dingdan-global-customer-service')) {
    //     const eventDiv = document.createElement('div')
    //     eventDiv.id = 'dingdan-global-customer-service'

    //     document.body.appendChild(eventDiv)
    //     const timestamp = Date.now()
    //     const nonce = randomString()
    //     const web_token = localStorage.getItem('token')
    //     if (!web_token) {
    //         return
    //     }
    
    //     const script = document.createElement('script')
    //     // todo墨子后面优化
    //     // script.async = true
    //     script.defer = true
    //     script.src = 'https://assets-cli.s4.udesk.cn/im_client/js/udeskApi.js'
    //     const tag = document.getElementsByTagName('script')[0]
    //     tag && tag.parentNode && tag.parentNode.insertBefore(script, tag)
    
    //     const { nickName, name: userName, phone, avatar } = globalModule.userInfo
    //     const { name, ntwNum, type, finalVersion, versionList } = globalModule.networkInfo
    //     window.ud({
    //         code: '1684fc8a',
    //         panel: {
    //             css: {
    //                 right: 0
    //             }
    //         },
    //         link,
    //         isInvite: true,
    //         group_id: groupId,
    //         mode: 'inner',
    //         language: 'zh-cn',
    //         onlineText: '您好，订单来了为您服务！',
    //         offlineText: '当前无客服在线，请在工作日9:00至21:00点联系客服',
    //         targetSelector: '#dingdan-global-customer-service',
    //         selector: '.dingdan-global-customer-service',
    //         merchant_name: name + '-' + (nickName || userName),
    //         merchant_avatar: avatar,
    //         customer: {
    //             c_name: nickName || userName,
    //             c_phone: phone,
    //             c_cf_网络名称: name,
    //             c_cf_网络号: ntwNum,
    //             c_cf_客户昵称: nickName || userName,
    //             c_cf_系统: '新系统web',
    //             c_cf_网络类型: NTW_TYPE[type || 1],
    //             c_cf_网络版本: versionList?.find(item => item.identify === finalVersion)?.versionName || '-',
    //             c_cf_老系统网络版本: '无',
    //             timestamp,
    //             nonce,
    //             signature: sha1(`nonce=${nonce}&timestamp=${timestamp}&web_token=${web_token}&${IM_CUSTOMER_KEY}`)
    //                 .toString()
    //                 .toUpperCase(),
    //             web_token,
    //             customer_token: web_token,
    //         }
    //     })
    // }

}
